export const isDeniedRequest = (error) => {
    try {
        const message = error.message;
        if (message === null || message === void 0 ? void 0 : message.includes('401'))
            return true;
    }
    catch (error) {
        console.warn(error);
    }
    return false;
};
export function spliceUrl(baseUrl, extendArg) {
    return extendArg ? baseUrl + '/' + extendArg : baseUrl;
}
export function getRequestConfig(base, config) {
    if (typeof base === 'string') {
        return config;
    }
    else {
        const { baseConfig } = base || {};
        const { query, method, params, data } = config || {};
        return Object.assign(Object.assign(Object.assign({}, config), baseConfig), { query: (baseConfig.query || '') + (query || ''), method: method ? method : baseConfig.method, params: Object.assign({}, baseConfig.params, params), data: Object.assign({}, baseConfig.data, data) });
    }
}
